import { FinalCTA } from './sections/FinalCTA';
import { FreeSection } from './sections/FreeSection';
import { Hero } from './sections/Hero';
import { HowItWorks } from './sections/HowItWorks';
import { LandingFooter } from './sections/LandingFooter';
import { LandingNav } from './sections/LandingNav';
import { TemplateGallery } from './sections/TemplateGallery';
import { Testimonial } from './sections/Testimonial';
import { TrustStrip } from './sections/TrustStrip';
import { ValuePillars } from './sections/ValuePillars';

export function LandingPage() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-canvas pt-20 text-ink">
      <LandingNav />
      <Hero />
      <TrustStrip />
      <ValuePillars />
      <HowItWorks />
      <TemplateGallery />
      <Testimonial />
      <FreeSection />
      <FinalCTA />
      <LandingFooter />
    </div>
  );
}
